export const HistoryPlaceIcon = ({
  width = '24',
  height = '24',
  fill = '#0F2664',
}) => {
  return (
    <div className="feature">
      <svg
        width={width}
        height={height}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12.5576 13.125H17.25V15H21L22.5 19.875"
          stroke={fill}
          strokeWidth="0.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.7554 17.3374C15.7801 17.1074 15.8889 16.8946 16.061 16.74C16.2331 16.5855 16.4563 16.5 16.6876 16.5C16.9363 16.5 17.1747 16.5988 17.3505 16.7746C17.5263 16.9504 17.6251 17.1889 17.6251 17.4375V19.8641"
          stroke={fill}
          strokeWidth="0.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M18.75 19.8641V17.4375C18.75 17.1889 18.8488 16.9504 19.0246 16.7746C19.2004 16.5988 19.4389 16.5 19.6875 16.5C19.9361 16.5 20.1746 16.5988 20.3504 16.7746C20.5262 16.9504 20.625 17.1889 20.625 17.4375V19.8641"
          stroke={fill}
          strokeWidth="0.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.72232 10.6856L8.51782 7.875"
          stroke={fill}
          strokeWidth="0.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.3069 15.269L12 12.4377"
          stroke={fill}
          strokeWidth="0.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17.2499 19.8751L15.1184 16.6782"
          stroke={fill}
          strokeWidth="0.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.25 6.375H1.5C1.08579 6.375 0.75 6.71079 0.75 7.125C0.75 7.53921 1.08579 7.875 1.5 7.875H8.25C8.66421 7.875 9 7.53921 9 7.125C9 6.71079 8.66421 6.375 8.25 6.375Z"
          stroke={fill}
          strokeWidth="0.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.625 10.875H1.5C1.08579 10.875 0.75 11.2108 0.75 11.625C0.75 12.0392 1.08579 12.375 1.5 12.375H11.625C12.0392 12.375 12.375 12.0392 12.375 11.625C12.375 11.2108 12.0392 10.875 11.625 10.875Z"
          stroke={fill}
          strokeWidth="0.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.25 15.375H1.5C1.08579 15.375 0.75 15.7108 0.75 16.125C0.75 16.5392 1.08579 16.875 1.5 16.875H14.25C14.6642 16.875 15 16.5392 15 16.125C15 15.7108 14.6642 15.375 14.25 15.375Z"
          stroke={fill}
          strokeWidth="0.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M23.25 19.875H0.75V21.375H23.25V19.875Z"
          stroke={fill}
          strokeWidth="0.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1.5 10.875V9.75C1.5 9.55109 1.57902 9.36032 1.71967 9.21967C1.86032 9.07902 2.05109 9 2.25 9C2.44891 9 2.63968 9.07902 2.78033 9.21967C2.92098 9.36032 3 9.55109 3 9.75V10.875"
          stroke={fill}
          strokeWidth="0.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4.125 10.875V9.75C4.125 9.55109 4.20402 9.36032 4.34467 9.21967C4.48532 9.07902 4.67609 9 4.875 9C5.07391 9 5.26468 9.07902 5.40533 9.21967C5.54598 9.36032 5.625 9.55109 5.625 9.75V10.875"
          stroke={fill}
          strokeWidth="0.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.75 10.875V9.75C6.75 9.55109 6.82902 9.36032 6.96967 9.21967C7.11032 9.07902 7.30109 9 7.5 9C7.69891 9 7.88968 9.07902 8.03033 9.21967C8.17098 9.36032 8.25 9.55109 8.25 9.75V10.875"
          stroke={fill}
          strokeWidth="0.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1.5 15.375V14.25C1.5 14.0511 1.57902 13.8603 1.71967 13.7197C1.86032 13.579 2.05109 13.5 2.25 13.5C2.44891 13.5 2.63968 13.579 2.78033 13.7197C2.92098 13.8603 3 14.0511 3 14.25V15.375"
          stroke={fill}
          strokeWidth="0.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4.125 15.375V14.25C4.125 14.0511 4.20402 13.8603 4.34467 13.7197C4.48532 13.579 4.67609 13.5 4.875 13.5C5.07391 13.5 5.26468 13.579 5.40533 13.7197C5.54598 13.8603 5.625 14.0511 5.625 14.25V15.375"
          stroke={fill}
          strokeWidth="0.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.75 15.375V14.25C6.75 14.0511 6.82902 13.8603 6.96967 13.7197C7.11032 13.579 7.30109 13.5 7.5 13.5C7.69891 13.5 7.88968 13.579 8.03033 13.7197C8.17098 13.8603 8.25 14.0511 8.25 14.25V15.375"
          stroke={fill}
          strokeWidth="0.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.375 15.375V14.25C9.375 14.0511 9.45402 13.8603 9.59467 13.7197C9.73532 13.579 9.92609 13.5 10.125 13.5C10.3239 13.5 10.5147 13.579 10.6553 13.7197C10.796 13.8603 10.875 14.0511 10.875 14.25V15.375"
          stroke={fill}
          strokeWidth="0.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1.5 19.875V18.75C1.5 18.5511 1.57902 18.3603 1.71967 18.2197C1.86032 18.079 2.05109 18 2.25 18C2.44891 18 2.63968 18.079 2.78033 18.2197C2.92098 18.3603 3 18.5511 3 18.75V19.875"
          stroke={fill}
          strokeWidth="0.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4.125 19.875V18.75C4.125 18.5511 4.20402 18.3603 4.34467 18.2197C4.48532 18.079 4.67609 18 4.875 18C5.07391 18 5.26468 18.079 5.40533 18.2197C5.54598 18.3603 5.625 18.5511 5.625 18.75V19.875"
          stroke={fill}
          strokeWidth="0.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.75 19.875V18.75C6.75 18.5511 6.82902 18.3603 6.96967 18.2197C7.11032 18.079 7.30109 18 7.5 18C7.69891 18 7.88968 18.079 8.03033 18.2197C8.17098 18.3603 8.25 18.5511 8.25 18.75V19.875"
          stroke={fill}
          strokeWidth="0.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.375 19.875V18.75C9.375 18.5511 9.45402 18.3603 9.59467 18.2197C9.73532 18.079 9.92609 18 10.125 18C10.3239 18 10.5147 18.079 10.6553 18.2197C10.796 18.3603 10.875 18.5511 10.875 18.75V19.875"
          stroke={fill}
          strokeWidth="0.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12 19.875V18.75C12 18.5511 12.079 18.3603 12.2197 18.2197C12.3603 18.079 12.5511 18 12.75 18C12.9489 18 13.1397 18.079 13.2803 18.2197C13.421 18.3603 13.5 18.5511 13.5 18.75V19.875"
          stroke={fill}
          strokeWidth="0.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1.5 7.875V10.875"
          stroke={fill}
          strokeWidth="0.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1.5 12.375V15"
          stroke={fill}
          strokeWidth="0.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1.5 17.25V19.875"
          stroke={fill}
          strokeWidth="0.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  );
};
